import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Select, Typography, Radio, Spin } from 'antd';
import { Formik, Field, Form as FormikForm } from 'formik';
import * as Yup from 'yup';
import 'antd/dist/reset.css';
import '../App.css'; // Кастомные стили
import WeddingMap from './Map';
import { motion } from 'framer-motion';
import { Client, Databases } from 'appwrite'; // Импортируем Appwrite
import axios from 'axios';

const { Title, Text } = Typography;

// Инициализация клиента Appwrite
const client = new Client()
    .setEndpoint('https://cloud.appwrite.io/v1') // укажи свой endpoint
    .setProject('679b9cb60005e8f57e41'); // укажи свой project ID

const databases = new Databases(client);

const sendToTelegram = async (message) => {
    const botToken = '7408947421:AAE-w4ykGq1BXBqspHJXwgX2CRqIc2VReJc'; // Замените на ваш токен
    const chatId = '1067214786'; // Замените на ваш ID чата

    try {
        await axios.post(`https://api.telegram.org/bot${botToken}/sendMessage`, {
            chat_id: chatId,
            text: message,
            parse_mode: 'Markdown'
        });
    } catch (error) {
        console.error("Ошибка отправки сообщения в Telegram", error);
    }
};

const Invitation = () => {
    const [guests, setGuests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentSection, setCurrentSection] = useState(0);
    const location = useLocation();
    const [guestId, setGuestId] = useState('');

    const getQueryParams = () => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get('guestId');
    };

    // Функция для загрузки данных о гостях
    const loadGuestData = async (guestId) => {
        try {
            const response = await databases.listDocuments(
                '679b9ed7000c23b957ee', // ID базы
                '679b9f9a000bd1b785f3'  // ID коллекции
            );

            // Фильтруем документы по guestId
            const filteredGuests = response.documents.filter(doc => doc.guestId === guestId);
            // Преобразуем данные в нужный формат
            const guestsData = filteredGuests.map((doc) => ({
                documentId: doc.$id,
                name: doc.name,
                attending: doc.attending,
                alcohol: doc.alcohol
            }));

            console.log("Filtered guests:", guestsData);  // Логируем для проверки

            setGuests(guestsData); // Устанавливаем данные гостей
            setLoading(false); // Останавливаем загрузку
        } catch (error) {
            console.error("Ошибка при загрузке данных:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        const id = getQueryParams();
        console.log("Полученный ID из URL:", id);
        setGuestId(id);
        if (id) {
            loadGuestData(id);
        } else {
            setLoading(false); // Если ID нет, прекращаем загрузку
        }
    }, [location]);

    // Функция для отслеживания видимости блоков
    const handleScroll = () => {
        const sections = document.querySelectorAll('.section');
        const threshold = 200; // Точка, после которой блок будет отображаться
        sections.forEach((section, index) => {
            const rect = section.getBoundingClientRect();
            if (rect.top <= window.innerHeight - threshold && rect.bottom >= threshold) {
                setCurrentSection(index);
            }
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const validationSchema = Yup.array().of(
        Yup.object().shape({
            attending: Yup.boolean().nullable().required('Выберите статус участия'),
            alcohol: Yup.string().required('Выберите алкоголь').nullable(),
        })
    );

    const updateGuestData = async (updatedGuests) => {
        try {
            for (const guest of updatedGuests) {
                // Проверка на наличие documentId у гостя
                if (!guest.documentId) {
                    console.error('Не найден ID документа для гостя', guest);
                    continue;
                }

                // Обновление данных по guestId
                const response = await databases.updateDocument(
                    '679b9ed7000c23b957ee', // ID базы данных
                    '679b9f9a000bd1b785f3', // ID коллекции
                    guest.documentId, // ID документа, который обновляем
                    {
                        attending: guest.attending, // Обновляем поле "attending"
                        alcohol: guest.alcohol,     // Обновляем поле "alcohol"
                    }
                );

                console.log('Документ обновлен успешно', response);
            }
        } catch (error) {
            console.error('Ошибка при обновлении данных:', error);
        }
    };

    if (loading) return <Spin size="large" className="loading-indicator" />;

    const guestNames = guests.map((guest) => guest.name);
    let greeting;

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth', // Для плавной прокрутки
                block: 'start' // Прокрутка к началу блока
            });
        }
    };


    if (guestNames.length === 1) {
        greeting = `Здравствуйте, <strong>${guestNames[0]}</strong>!`;
    } else if (guestNames.length > 1) {
        greeting = `Здравствуйте дорогие <strong>${guestNames.slice(0, -1).join('</strong>, <strong>')}</strong> и <strong>${guestNames[guestNames.length - 1]}</strong>!`;
    }

    return (
        <div className="invitation-container">
            {/* Секция 1: Приглашение на свадьбу */}
            <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: currentSection >= 0 ? 1 : 0, y: currentSection >= 0 ? 0 : 50 }}
                transition={{ duration: 0.3 }}
                className="section"
                style={{
                    height: '100vh',
                    padding: '20px 0',
                    position: 'relative',
                    width: '100%',
                    zIndex: 10,
                }}
            >
                <Title level={2} style={{ fontFamily: 'Great Vibes, serif' }}>
                    Приглашение на свадьбу
                </Title>
                <div
                    className="wedding-description"
                    dangerouslySetInnerHTML={{ __html: greeting }}

                    style={{
                        width: '70%', // Ограничиваем ширину
                        margin: '0 auto', // Центрируем
                        textAlign: 'center', // Выравнивание по центру
                        padding: '20px',
                        boxSizing: 'border-box',
                    }}
                />
                <Text className="wedding-description" style={{ display: 'block', textAlign: 'center' }}>
                    <br />С радостью приглашаем вас разделить с нами один из самых важнейших дней в нашей жизни — наш свадебный день!

                    <br /><strong>Когда:</strong> 5 сентября 2025 года
                    <div style={{ display: 'inline' }}><br /><strong>Где:</strong> Вы можете ознакомится с местом проведения в соответствующем разделе <Text className="wedding-description" style={{ display: 'inline', textAlign: 'center', textDecoration: 'underline' }} onClick={() => scrollToSection('section-2')}> Место проведения </Text></div>
                    <div style={{ display: 'inline' }}><br /><strong>Время:</strong> Начало в 15:00, а с более подробным таймингом вы можете ознакомится в соответствующем разделе <Text className="wedding-description" style={{ display: 'inline', textAlign: 'center', textDecoration: 'underline' }} onClick={() => scrollToSection('section-3')}> Тайминг </Text></div>

                    <br />Будем счастливы видеть вас среди наших гостей, чтобы вместе отметить этот незабываемый момент. Ожидаем вас с нетерпением и надеемся, что ваше присутствие сделает наш день ещё более особенным!

                    <br /><strong>Пожалуйста, подтвердите своё присутствие, заполнив форму ниже.</strong>

                    <br />До встречи на свадьбе!
                    <br />С любовью, <strong>Никита и Полина</strong>
                </Text>
            </motion.div>

            {/* Секция 2: Карта с описанием места */}
            <motion.div
                id="section-2"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: currentSection >= 1 ? 1 : 0, y: currentSection >= 1 ? 0 : 50 }}
                transition={{ duration: 0.3 }}
                className="section"
                style={{
                    height: '100vh',
                    padding: '20px 0',
                    position: 'relative',
                    width: '100%',
                    zIndex: 9,
                }}
            >
                <div className="map-container" style={{ width: '70%', margin: '0 auto' }}>
                    <Title level={2} style={{ fontFamily: 'Great Vibes, serif' }}>
                        Место проведения
                    </Title>
                    <Text className="wedding-description" style={{ display: 'block', textAlign: 'center' }}>
                        Загородный клуб "ЗаВидное" — это уединенное и красивое место, где мы будем отмечать наш важный день...
                    </Text>
                    <WeddingMap />
                </div>
            </motion.div>

            {/* Секция 3: Тайминг мероприятия */}
            <motion.div
                id="section-3"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: currentSection >= 2 ? 1 : 0, y: currentSection >= 2 ? 0 : 50 }}
                transition={{ duration: 0.3 }}
                className="section"
                style={{
                    height: '100vh',
                    padding: '20px 0',
                    position: 'relative',
                    width: '100%',
                    zIndex: 8,
                }}
            >
                <div className="timeline-section">
                    <Title level={3} className="timeline-title" style={{ textAlign: 'center' }}>
                        Тайминг мероприятия
                    </Title>


                    <ul className="timeline">
                        <li className="timeline-item">
                            <div className="timeline-time">15:00</div>
                            <div className="timeline-content"><Text className="wedding-description">Сбор гостей</Text></div>
                        </li>
                        <li className="timeline-item">
                            <div className="timeline-time">16:00</div>
                            <div className="timeline-content"><Text className="wedding-description">Церемония выездной регистрации</Text></div>
                        </li>
                        <li className="timeline-item">
                            <div className="timeline-time">17:00</div>
                            <div className="timeline-content"><Text className="wedding-description">Банкет</Text></div>
                        </li>
                        <li className="timeline-item">
                            <div className="timeline-time">??:??</div>
                            <div className="timeline-content"><Text className="wedding-description">Первый танец</Text></div>
                        </li>
                        <li className="timeline-item">
                            <div className="timeline-time">??:??</div>
                            <div className="timeline-content"><Text className="wedding-description">Бросание букета</Text></div>
                        </li>
                        <li className="timeline-item">
                            <div className="timeline-time">22:00</div>
                            <div className="timeline-content"><Text className="wedding-description">Торжественное окончание вечера</Text></div>
                        </li>
                        <li className="timeline-item">
                            <div className="timeline-time">23:00</div>
                            <div className="timeline-content"><Text className="wedding-description">Окончание дискотеки</Text></div>
                        </li>
                    </ul>
                </div>
            </motion.div>

            {/* Секция 4: Дресс-код */}
            <motion.div
                id="section-4"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: currentSection >= 2 ? 1 : 0, y: currentSection >= 2 ? 0 : 50 }}
                transition={{ duration: 0.3 }}
                className="section"
                style={{
                    height: '100vh',
                    padding: '20px 0',
                    position: 'relative',
                    width: '100%',
                    zIndex: 8,
                }}
            >

                <Title level={3} className="timeline-title" style={{ textAlign: 'center' }}>
                    Дресс-код
                </Title>
                <Text className="wedding-description" style={{ display: 'block', textAlign: 'center' }}>
                    Для нас очень важен дресс-код на свадьбе, и мы бы хотели, чтобы каждый из наших гостей чувствовал себя частью этого праздника. Мы предлагаем выбрать для нарядов оттенки зелёного, коричневого и бежевого — они будут гармонично сочетаться с атмосферой нашего мероприятия.
                </Text>

            </motion.div>

            {/* Секция 5: Ответьте на приглашение */}
            <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: currentSection >= 3 ? 1 : 0, y: currentSection >= 3 ? 0 : 50 }}
                transition={{ duration: 0.3 }}
                className="section"
                style={{
                    height: '100vh',
                    padding: '20px 0',
                    position: 'relative',
                    width: '100%',
                    zIndex: 7,
                }}
            >
                <div className="form-section">
                    <Title level={3} className="form-title" style={{ textAlign: 'center' }}>
                        Ответьте на приглашение
                    </Title>
                    <Formik
                        initialValues={{ guests }}  // Убедитесь, что передаются правильные начальные значения
                        validationSchema={validationSchema}
                        onSubmit={async (values) => {
                            console.log('Submitted:', values.guests);

                            // Обновляем данные в Appwrite
                            await updateGuestData(values.guests);
                            const message = 'GuestId:'+ guestId+'\n'+ values.guests.map(guest => {
                                return `*${guest.name}*: \n-*Приду*: ${guest.attending == null ? "Не знаю" : guest.attending ? 'Да' : 'Нет'} \n-*Алкоголь*: ${guest.alcohol || 'Не выбрано'}`;
                            }).join("\n\n");

                            // Отправка данных в Telegram
                            await sendToTelegram(message);

                            alert('Ваши ответы успешно отправлены!');
                        }}
                    >
                        {({ values, setFieldValue }) => (
                            <FormikForm>
                                {guests.map((guest, index) => (
                                    <div key={index} className="guest-form">
                                        <div className="wedding-description"><strong>{guest.name}</strong></div>
                                        <Field
                                            name={`guests[${index}].attending`}
                                            as={Radio.Group}
                                            value={values.guests[index].attending}
                                            onChange={(e) =>
                                                setFieldValue(`guests[${index}].attending`, e.target.value)
                                            }
                                            optionType="button"
                                            buttonStyle="solid"
                                        >
                                            <Radio.Button value={true} className="wedding-description">Приду</Radio.Button>
                                            <Radio.Button value={null} className="wedding-description">Не знаю</Radio.Button>
                                            <Radio.Button value={false} className="wedding-description">Не приду</Radio.Button>
                                        </Field>
                                        <Field
                                            name={`guests[${index}].alcohol`}
                                            as={Select}
                                            value={values.guests[index].alcohol} // Убедитесь, что значения правильно синхронизируются
                                            onChange={(value) => setFieldValue(`guests[${index}].alcohol`, value)} // Обновляем значение
                                            className="wedding-description"
                                            style={{ width: '100%' }}
                                        >
                                            <Select.Option value="Вино"><Text className="wedding-description">Вино</Text></Select.Option>
                                            <Select.Option value="Пиво"><Text className="wedding-description">Пиво</Text></Select.Option>
                                            <Select.Option value="Без алкоголя"><Text className="wedding-description">Без алкоголя</Text></Select.Option>
                                        </Field>
                                    </div>
                                ))}
                                <Button type="primary" htmlType="submit" className="wedding-description">
                                    Отправить ответы
                                </Button>
                            </FormikForm>
                        )}
                    </Formik>
                </div>
            </motion.div>
        </div>
    );
};

export default Invitation;
